import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const LearningPageMainSection = ({
  children,
  flexGrow = 1,
  minInlineSize
}) => {
  return /*#__PURE__*/_jsx(View, {
    flexGrow: flexGrow,
    minInlineSize: minInlineSize,
    children: children
  });
};
export default LearningPageMainSection;